

import ObjectCard from '../../components/Card/ObjectCard.vue'
import { getCustomTabsList } from './yandexAccountCardCustomTabs.js'

export default {
  extends: ObjectCard,
  data: function () {
    return {
      typeKeyLocal: 'yandexAccount' // @Override
    }
  },
  methods: {
    /**
     * ObjectCard
     */
    // @Override
    setObjectType: function (objectTypeKey) {
      // ignore Иначе typeKeyLocal перезапишется
    },
    // @Default
    getObjectName: function (objectSrc) {
      return objectSrc.fio || objectSrc.name || objectSrc.key
    },
    // @Override
    getRawCustomTabsList: function (config) {
      return getCustomTabsList(config)
    },
    // @Default
    checkUserAccess: function (user) {
      const access = this.getDefaultAccess()

      const fullAccess = user.hasRole('admin') && user.fullAccess

      access.editPrivate = fullAccess
      access.viewPrivate = fullAccess
      access.viewPublic = true
      access.editPublic = fullAccess

      access.editAny = access.editPublic
      return access
    }
  }
}
